import { writable } from "svelte/store"
import config from "./config"

let nav: Nav

export const activeNav = writable(nav)

export const jsonForOverlay = writable(null)

export const apiToken = writable(localStorage.getItem("apiToken") || "")

apiToken.subscribe((t) => {
    localStorage.setItem("apiToken", t)
})

export const apiBase = writable(config.apiBase[0].url)
